import React from "react";
import useTheme from "../../../../common/hooks/useTheme";
import { Theme } from "../../../../providers/ThemeProvider";
import { useClientSidePanel } from "../../../../providers/ClientSidePanelProvider";
import PrimaryButton from "../../../../common/ui/PrimaryButton";
import PlusIcon from "../../svg/PlusIcon";

interface ClientSidePanelToggleProps {
  showText?: boolean;
  openText?: string;
  closeText?: string;
  className?: string;
}

const ClientSidePanelToggle: React.FC<ClientSidePanelToggleProps> = ({}) => {
  const theme: Theme = useTheme();
  const { togglePanel } = useClientSidePanel();

  return (
    <PrimaryButton
      label={"New Prescription"}
      icon={<PlusIcon fill={theme.colors_ds.NEUTRAL_GENERAL_WHITE} />}
      onClick={togglePanel}
    />
  );
};

export default ClientSidePanelToggle;
